import React from 'react';
import './Home.css';
import VideoCarousel from '../components/Shared/VideoCarousel';
import Modes from '../components/Shared/Modes';
import DetectorText from '../components/Shared/DetectorText';
import Mouse from '../components/Shared/Mouse';
import { Helmet } from 'react-helmet';

const blinkVideos = [
  {src: '/videos/blinks_mike.mp4'},
  {src: '/videos/blinks_chess.mp4'},
  {src: '/videos/blinks_vim.mp4'},
];

const Blinks = () => {
  return (
    <div>
      <Helmet>
        <title>FaceLead - Control your computer by blinking</title>
        <meta name="description" content="No need for a mouse, a keyboard, or any additional hardware. Take full control of your computer by blinking." />
      </Helmet>
      <VideoCarousel
        videos={blinkVideos}
        mainTitle="Control your computer by blinking"
        subTitle='No need for a mouse, a keyboard, or any additional hardware. Take full control of your computer by blinking.'
      />
      <DetectorText
        title="Ready to use approach"
        content="Work with 2 inputs, a single-blink and a double-blink. You can adjust speed and eyes shape variables. No need to train with custom data."
        docLink = '/docs/blinks'
      />
      <Modes videoSrc='/videos/modes_blinks.mp4' />
      <Mouse splitLeadShared='Move the cursor by blinking' />
    </div>
  );
};


export default Blinks;
